import { render, staticRenderFns } from "./OwnerAppadvertisingList.vue?vue&type=template&id=943fc24a&"
import script from "./OwnerAppadvertisingList.vue?vue&type=script&lang=js&"
export * from "./OwnerAppadvertisingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports